/*
  Campaign page: clicks that did not go as planned. Merged FIRST into
  TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const ru = {
  "Clicks that did not go as planned (7 days)": "Клики, которые пошли не по плану (7 дней)",
  "Counted up to a minute late.": "Учитываются с задержкой до минуты.",
  "Reason": "Причина",
  "Clicks": "Клики",
  "Last": "Последний",
  "Blocked by protection (filters, bot and IP lists).": "Заблокирован защитой (фильтры, списки ботов и IP).",
  "Opened on another domain than the campaign is bound to: the visitor got an error.": "Открыт на другом домене, а не на том, к которому привязана кампания: посетитель получил ошибку.",
  "Went to the default URL of the campaign: no stream matched, a stream had no address, or the campaign has no streams.": "Ушёл на адрес кампании по умолчанию: не подошёл ни один поток, у потока не было адреса или у кампании нет потоков.",
  "The account had no active subscription: the link did not open.": "У аккаунта не было активной подписки: ссылка не открылась.",
};

const es = {
  "Clicks that did not go as planned (7 days)": "Clics que no salieron como estaba previsto (7 días)",
  "Counted up to a minute late.": "Se cuentan con hasta un minuto de retraso.",
  "Reason": "Motivo",
  "Clicks": "Clics",
  "Last": "Último",
  "Blocked by protection (filters, bot and IP lists).": "Bloqueado por la protección (filtros, listas de bots e IP).",
  "Opened on another domain than the campaign is bound to: the visitor got an error.": "Abierto en otro dominio distinto al de la campaña: el visitante recibió un error.",
  "Went to the default URL of the campaign: no stream matched, a stream had no address, or the campaign has no streams.": "Fue a la URL por defecto de la campaña: ningún flujo coincidió, un flujo no tenía dirección o la campaña no tiene flujos.",
  "The account had no active subscription: the link did not open.": "La cuenta no tenía una suscripción activa: el enlace no se abrió.",
};

const pt = {
  "Clicks that did not go as planned (7 days)": "Cliques que não saíram como planejado (7 dias)",
  "Counted up to a minute late.": "Contados com até um minuto de atraso.",
  "Reason": "Motivo",
  "Clicks": "Cliques",
  "Last": "Último",
  "Blocked by protection (filters, bot and IP lists).": "Bloqueado pela proteção (filtros, listas de bots e IPs).",
  "Opened on another domain than the campaign is bound to: the visitor got an error.": "Aberto em outro domínio que não o da campanha: o visitante recebeu um erro.",
  "Went to the default URL of the campaign: no stream matched, a stream had no address, or the campaign has no streams.": "Foi para a URL padrão da campanha: nenhum fluxo correspondeu, um fluxo não tinha endereço ou a campanha não tem fluxos.",
  "The account had no active subscription: the link did not open.": "A conta não tinha assinatura ativa: o link não abriu.",
};

const de = {
  "Clicks that did not go as planned (7 days)": "Klicks, die nicht wie geplant liefen (7 Tage)",
  "Counted up to a minute late.": "Mit bis zu einer Minute Verzögerung gezählt.",
  "Reason": "Grund",
  "Clicks": "Klicks",
  "Last": "Zuletzt",
  "Blocked by protection (filters, bot and IP lists).": "Vom Schutz blockiert (Filter, Bot- und IP-Listen).",
  "Opened on another domain than the campaign is bound to: the visitor got an error.": "Auf einer anderen Domain geöffnet als der, an die die Kampagne gebunden ist: Der Besucher bekam einen Fehler.",
  "Went to the default URL of the campaign: no stream matched, a stream had no address, or the campaign has no streams.": "Ging auf die Standard-URL der Kampagne: kein Stream passte, ein Stream hatte keine Adresse oder die Kampagne hat keine Streams.",
  "The account had no active subscription: the link did not open.": "Das Konto hatte kein aktives Abonnement: Der Link öffnete sich nicht.",
};

const fr = {
  "Clicks that did not go as planned (7 days)": "Clics qui ne se sont pas passés comme prévu (7 jours)",
  "Counted up to a minute late.": "Comptés avec jusqu’à une minute de retard.",
  "Reason": "Raison",
  "Clicks": "Clics",
  "Last": "Dernier",
  "Blocked by protection (filters, bot and IP lists).": "Bloqué par la protection (filtres, listes de bots et d’IP).",
  "Opened on another domain than the campaign is bound to: the visitor got an error.": "Ouvert sur un autre domaine que celui de la campagne : le visiteur a reçu une erreur.",
  "Went to the default URL of the campaign: no stream matched, a stream had no address, or the campaign has no streams.": "Envoyé vers l’URL par défaut de la campagne : aucun flux ne correspondait, un flux n’avait pas d’adresse ou la campagne n’a pas de flux.",
  "The account had no active subscription: the link did not open.": "Le compte n’avait pas d’abonnement actif : le lien ne s’est pas ouvert.",
};

const it = {
  "Clicks that did not go as planned (7 days)": "Clic che non sono andati come previsto (7 giorni)",
  "Counted up to a minute late.": "Contati con un ritardo fino a un minuto.",
  "Reason": "Motivo",
  "Clicks": "Clic",
  "Last": "Ultimo",
  "Blocked by protection (filters, bot and IP lists).": "Bloccato dalla protezione (filtri, liste di bot e IP).",
  "Opened on another domain than the campaign is bound to: the visitor got an error.": "Aperto su un dominio diverso da quello della campagna: il visitatore ha ricevuto un errore.",
  "Went to the default URL of the campaign: no stream matched, a stream had no address, or the campaign has no streams.": "È andato all’URL predefinito della campagna: nessun flusso corrispondeva, un flusso non aveva indirizzo o la campagna non ha flussi.",
  "The account had no active subscription: the link did not open.": "L’account non aveva un abbonamento attivo: il link non si è aperto.",
};

const pl = {
  "Clicks that did not go as planned (7 days)": "Kliknięcia, które nie poszły zgodnie z planem (7 dni)",
  "Counted up to a minute late.": "Liczone z opóźnieniem do minuty.",
  "Reason": "Powód",
  "Clicks": "Kliknięcia",
  "Last": "Ostatnie",
  "Blocked by protection (filters, bot and IP lists).": "Zablokowane przez ochronę (filtry, listy botów i IP).",
  "Opened on another domain than the campaign is bound to: the visitor got an error.": "Otwarte w innej domenie niż ta, do której przypisana jest kampania: odwiedzający dostał błąd.",
  "Went to the default URL of the campaign: no stream matched, a stream had no address, or the campaign has no streams.": "Trafiło na domyślny adres kampanii: żaden strumień nie pasował, strumień nie miał adresu lub kampania nie ma strumieni.",
  "The account had no active subscription: the link did not open.": "Konto nie miało aktywnej subskrypcji: link się nie otworzył.",
};

const tr = {
  "Clicks that did not go as planned (7 days)": "Planlandığı gibi gitmeyen tıklamalar (7 gün)",
  "Counted up to a minute late.": "Bir dakikaya kadar gecikmeyle sayılır.",
  "Reason": "Neden",
  "Clicks": "Tıklamalar",
  "Last": "Son",
  "Blocked by protection (filters, bot and IP lists).": "Koruma tarafından engellendi (filtreler, bot ve IP listeleri).",
  "Opened on another domain than the campaign is bound to: the visitor got an error.": "Kampanyanın bağlı olduğu alan adından farklı bir alan adında açıldı: ziyaretçi hata aldı.",
  "Went to the default URL of the campaign: no stream matched, a stream had no address, or the campaign has no streams.": "Kampanyanın varsayılan URL’sine gitti: hiçbir akış eşleşmedi, bir akışın adresi yoktu veya kampanyada akış yok.",
  "The account had no active subscription: the link did not open.": "Hesabın etkin aboneliği yoktu: bağlantı açılmadı.",
};

const uk = {
  "Clicks that did not go as planned (7 days)": "Кліки, які пішли не за планом (7 днів)",
  "Counted up to a minute late.": "Враховуються із затримкою до хвилини.",
  "Reason": "Причина",
  "Clicks": "Кліки",
  "Last": "Останній",
  "Blocked by protection (filters, bot and IP lists).": "Заблоковано захистом (фільтри, списки ботів та IP).",
  "Opened on another domain than the campaign is bound to: the visitor got an error.": "Відкрито на іншому домені, а не на тому, до якого прив’язана кампанія: відвідувач отримав помилку.",
  "Went to the default URL of the campaign: no stream matched, a stream had no address, or the campaign has no streams.": "Пішов на адресу кампанії за замовчуванням: не підійшов жоден потік, у потоку не було адреси або в кампанії немає потоків.",
  "The account had no active subscription: the link did not open.": "В акаунта не було активної підписки: посилання не відкрилося.",
};

const CLICK_ISSUES = { ru, es, pt, de, fr, it, pl, tr, uk };
export default CLICK_ISSUES;
